export default __webpack_public_path__ + "static/media/20.34d9e1a2.png";